/** Per-check reviewer comments (required when marking Fail). */

import type { CheckAnswers, CheckComments, PhaseCriteria } from "./types";

export function failCommentsComplete(
  criteria: PhaseCriteria,
  answers: CheckAnswers,
  comments: CheckComments,
): boolean {
  for (const check of criteria.checks) {
    if (answers[check.id] === "fail" && !comments[check.id]?.trim()) {
      return false;
    }
  }
  return true;
}

export function emptyCheckComments(): CheckComments {
  return {};
}
